// OWNER: Agent C. Every UK row shows both currencies — "£12,340 · ₹13,20,450"
// — with the FX rate and its timestamp always visible in a subline (not
// hover-only: hover doesn't exist on the phone the owner checks this from).
import { formatMoney, formatInr, formatRelativeAge } from "@shared/format";
import type { Currency } from "@shared/types";

export function MoneyDual({
  valueNative,
  nativeCurrency,
  valueInr,
  fxRate,
  fxAsOf,
  size = "base",
}: {
  valueNative: number;
  nativeCurrency: Currency;
  valueInr: number;
  fxRate?: number;
  fxAsOf?: string | null;
  size?: "sm" | "base" | "lg";
}) {
  const textSize = size === "lg" ? "text-lg" : size === "sm" ? "text-sm" : "text-base";
  if (nativeCurrency === "INR") {
    return <span className={`${textSize} text-kumo-default`}>{formatInr(valueInr)}</span>;
  }
  return (
    <div className="flex flex-col">
      <span className={`${textSize} text-kumo-default`}>
        {formatMoney(valueNative, nativeCurrency)} <span className="text-kumo-subtle">·</span> {formatInr(valueInr)}
      </span>
      {fxRate != null && (
        <span className="text-xs text-kumo-subtle">
          FX {fxRate.toFixed(2)}
          {fxAsOf ? ` · ${formatRelativeAge(fxAsOf)}` : ""}
        </span>
      )}
    </div>
  );
}
